const arrayTransformator = {
  toModelAttribute(value) {
    if (value == null || !Array.isArray(value)) {
      return null;
    }

    return value;
  },

  toFormAttribute(value) {
    if (value == null || !Array.isArray(value)) {
      return [];
    }
    return value;
  },
};

export default arrayTransformator;
